import React from 'react';
import { Col, Row, Spin, Typography } from 'antd';
import { useLoader } from '../../context/loaderContext';
import "./commonStyles.scss";
import { useFullScreenLoader } from '../../context/fullScreenLoaderContext';

const { Text } = Typography;

const FullScreenLoader = () => {
    const { loading, loadingText } = useFullScreenLoader();

    if (!loading) return null;

    return (
        <Row className="fullscreen-loader">
            <div className="loader-overlay"></div>
            <Col className="loader-content" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                <Spin size="large"/>
                <Text style={{ marginTop: 20 }}>{loadingText ? loadingText : "Loading..."}</Text>
            </Col>
        </Row>
    );
}
export default FullScreenLoader;